import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import { MultiLanguageSelector } from '@bingads-webui-campaign/multi-language-selector';

import template from './inline-editor-template.pug';
import ViewModel from './inline-editor-viewmodel';

/**
* Provide inline editoring function for campaign language
*
* <br>It reads user selection, and trigger these events:
* <br>  save: with { SelectedLanguages } after user click save
* <br>  close: after user click cancel
*
*/

export class CampaignLanguageInlineEditor extends Backbone.View {
  /**
   * Initilize view settings
   *
   * @param {Object} param - An object containing these default options for view:
   * @param {Object} param.item - the campaign entity to be edit
   *   to where to central the loading icon when update
   * @param {Object[]} param.languages - the languages set to choose from, default empty
   * @param {Object[]} param.i18n - the localization object which contains function getString
   *
   * @returns {void} void
  */
  initialize({
    item,
    languages = [],
    i18n = { getString: x => x },
  }) {
    this.item = item;
    this.languages = languages;
    this.i18n = i18n;
    this.viewModel = new ViewModel();
    this.viewModel.isValid(!_.isEmpty(this.item.Languages));
  }

  get events() {
    return {
      'click .grid-popupeditor-save': 'save',
      'click .grid-popupeditor-cancel': 'cancel',
    };
  }

  render() {
    this.$el.html(template({ i18n: this.i18n }));
    ko.applyBindings(this.viewModel, this.el);

    this.languageSelector = new MultiLanguageSelector({
      inEditMode: true,
      languages: this.languages,
      i18n: this.i18n,
      selectedLanguages: this.item.Languages,
    });

    this.$('.campaign-language-editor').html(this.languageSelector.render().el);

    this.languageSelector.on('selectedLanguages:changed', () => {
      this.viewModel.isValid(!_.isEmpty(this.languageSelector.getSelectedLanguages()));
    });

    return this;
  }

  save() {
    this.trigger('save', { SelectedLanguages: this.languageSelector.getSelectedLanguages() });
  }

  cancel() {
    this.trigger('close');
  }
}
